<template>
  <ag-modal-container
    :title="$t('user.title.updateUser')"
    width="900px"
    @close="back"
  >
    <user-form
      v-if="value"
      v-model="value"
      :submit-label="$t('general.update')"
      :forbidden-user-list="forbiddenUserList"
      @validate="isValid = $event"
    />

    <template v-slot:footer>
      <v-spacer />
      <v-btn
        color="primary"
        class="ml-5"
        outlined
        @click="back"
        v-text="$t('general.cancel')"
      />
      <v-btn
        :loading="loading"
        :disabled="!isValid || !value"
        color="primary"
        class="ml-5"
        @click="update"
        v-text="$t('general.update')"
      />
    </template>
  </ag-modal-container>
</template>

<script>
import { mapActions } from 'vuex'
import Repositories from 'src/repositories'

import AgModalContainer from 'src/components/common/AgModalContainer'
import UserForm from 'src/modules/user/components/UserForm'

export default {
  name: 'CompanyUserUpdateContainer',
  components: {
    AgModalContainer,
    UserForm,
  },
  props: {
    companyId: {
      type: String,
      required: true,
    },
    userId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    isValid: false,
    loading: false,
    value: null,
    forbiddenUserList: [],
  }),
  watch: {
    $route: {
      immediate: true,
      async handler () {
        this.value = await Repositories.company.user.get(this.companyId, this.userId)
      },
    },
  },
  methods: {
    ...mapActions('ui', {
      showSuccessNotification: 'showSuccessNotification',
      showErrorNotification: 'showErrorNotification',
    }),
    back () {
      this.$router.back()
    },
    async update () {
      this.loading = true
      try {
        await Repositories.company.user.patch(this.companyId, this.value)
        this.showSuccessNotification(this.$t('user.userUpdated'))
        this.back()
      }
      catch (error) {
        const notification = Repositories.parseErrorMessage(error)
        this.showErrorNotification(notification)

        // Username already exists
        if (Repositories.getErrorCode(error) === 'EditUserLoginTakenError') {
          this.forbiddenUserList.push(this.value.userLogin)
        }
      }
      finally {
        this.loading = false
      }
    },
  },
}
</script>
